export default {
  about: "Accueil",
  accomplish: "Compléter",
  account: "Compte",
  accountApplyList: "Création de compte",
  accountBusiness: "Création de compte",
  accountCancellation: "Fermeture de compte",
  accountDrawMoney: "Retrait de compte",
  accountList: "Liste des comptes",
  accountMaintenanceFees: "Frais de tenue de compte",
  accountRemittanceNotAccount: "Envoi de compte",
  accountType: "Type de compte",
  activityName: "Nom de l’activité",
  add: "Créer",
  addAccount: "Création de compte",
  addBalanceAdjustment: "Ajouter régularisation de solde",
  addBusiness: "Création d’opération",
  addConfig: "Création de configuration",
  addInterBankTransfer: "Ajouter un virement inter-banque",
  addRemunerationRules: "Création de règle",
  addRole: "Création de profile",
  addServiceChargeRules: "Création de règle",
  //addServiceChargeRulesCountries: "Création de règle entre pays",
  addServiceChargeRulesCountries: "Création de règle entre villes",
  address: "Adresse",
  addExpense: "Ajouter une dépense",
  expenseOperationCheck: "Validation de Dépenses",
  alerts: "Alertes",
  alertCEMTIF: "Alert CEMTIF",
  alertCenter: "Centre d'alertes",
  all: "Tout",
  allianceBusiness: "Distributeur",
  allianceBusinessJoin: "Ouverture de compte distributeur",
  allianceBusinessQuit: "Fermeture de compte distributeur",
  alternatePhone: "Téléphone secondaire",
  amountInvolvedRange: "Intervalle de montant",
  amountTransfer: "Montant du virement",
  //amount: "Montant",
  //
  adjustLimit: "Ajuster la limite de transaction",
  antiMoneyLaundering: "Anti-Money Laundering",
  transactionFiltering: "Filtrage de Transactions",
  transactionAlert: "Alert de Transactions",
  transactionsPPE: "Transactions PPE",
  listOfWantedPersons: "Liste des personnes recherchées",

  actions: "Actions",

  //
  applayRemark: "Remarque",
  applicationB: "Demande d'opération",
  applicationType: "Type d'opération",
  apply: "Demande",
  applyCode: "Code d'opération",
  applyId: "Numéro",
  applyInfo: "Information",
  areaConfig: "Pays et régions",
  auditor: "Validateur",
  backlog: "Encours",
  balanceAdjustment: "Régularisation de solde",
  selectBank: "Sélection de banque",
  bankAccount: "Compte bancaire",
  bankDeposit: "Dépôt bancaire",
  bankName: "Nom de la banque",
  bankDepositApply: "Ajouter un versement bancaire",
  bankWithdrawalApply: "Ajouter un retrait bancaire",
  basicInfo: "Informations de base",
  batchRemittancePayeeNotAccount: "Envoi multiple",
  batchTransfer: "Transfert multiple",
  batchPaymentStatements: "États paiements multiple",
  batchRemittanceList: "Liste envoi multiple",
  batchTransferList: "Liste Transfer multiple",
  beneficiaryAddress: "Adresse du bénéficiaire",
  beneficiariesAddress: "Ville des bénéficiaires",
  beneficiaryInfo: "Information du bénéficiaire",
  businessConfig: "Modification",
  businessHandling: "Opérations",
  businessLicense: "Registre du commerce",
  businessLicenseCode: "Numéro du registre de commerce",
  businessLicenseImage: "Photo du registre de commerce",
  businessManaged: "Gestion des opérations",
  businessMenu: "Menu des opérations",
  businessName: "Nom de l'opération",
  comingSoon: "Bientôt disponible",
  cancel: "Annuler",
  cancellationClientAccount: "Fermeture compte personnel",
  cancellationCompanyAccount: "Fermeture compte partenaire",
  cashNotAccount: "Envoi ordianire",
  channelAccountWithdrawalApplicationB: "Retrait de compte",
  channelCashWithdrawalB: "Retrait de cash",
  channelDealerManage: "Gestion des distributeurs",
  channelInformationInquiry: "Vérification des informations des distributeurs",
  channelMerchantAccountRechargeApplicationB: "Demande de recharge de compte",
  channelMerchantCashRechargeApplicationB: "Demande de recharge de cash",
  check: "Validation",
  checkBusiness: "Validations",
  checkInterBankTransfer: "Validation du virement inter-banque",
  checkOrg: "Validation d'organisation",
  checkPending: "Encours de validation",
  checkResult: "Résultat de validation",
  checkStatus: "État de validation",
  childBusiness: "Sous-opération",
  city: "Ville",
  close: "Fermer",
  closed: "CLOTURÉE",
  closingManagement: "Gestion des clotures",
  branchClosingStatements: "États des clôtures des agences",
  code: "Code",
  redeemRemittance: "Encaisser un envoi",
  comments: "Commentaire",
  confirm: "Confirmer",
  electronicMoneyOutstanding: "Encours Monnaie Électronique",
  advancedCustomerHistory: "Historique des partenaires",
  customerBalance: "Soldes Clients",
  orgBalance: "Soldes Distributeurs",
  cooperativePartnerJoin: "Création compte partenaire",
  cooperativePartnerQuit: "Fermeture compte partenaire",
  country: "Pays",
  coordination: "Coordination",
  "Please select country": "Pays d'origine",
  //creatorName: "Nom du créateur",
  createdAt: "Date de création",
  verifierName: "Nom du validateur",
  verificationRemark: "Remarque de validation",
  verifiedAt: "Date de validation",
  createdViaMobileApp: "Créé via mobile",
  creationTime: "Date de création",
  customer: "Client",
  customers_list: "Liste des clients",
  customersList: "Liste des comptes clients",
  customerID: "ID Client",
  customerLogin: "Connexion",
  currentAmountLimit: "Montant limit actuel",
  currentLimit: "Seuil actuel",
  dateTransaction: "Date de transaction",
  dealType: "Type d'opération",
  delete: "Supprimer",
  department: "Départment",
  DepositorFirstName: "Nom du déposant",
  DepositorLastName: "Prénom du déposant",
  DepositorPhoneNo: "Téléphone du déposant",
  deposit: "Dépôt cash",
  depositAmount: "Montant du dépôt",
  depositBusiness: "Opération de dépôt",
  depositInfo: "Information de dépôt",
  depositorInfo: "Information du déposant",
  depositManagement: "Gestion des dépôts",
  depositList: "Liste des dépôts",

  doneTime: "Date de fin",
  operateInfo: "Informations d'opération",
  customerInfo: "Informations client",
  detailedAddress: "Adresse",
  detailedInfo: "Details d'information",
  directSaleStore: "Agence BNIF",
  directStoreAccount: "Compte agence BNIF",
  download: "Téléchargement",
  drawMoneyBusiness: "Opération de retrait",
  edit: "Modifier",
  editAccount: "Modification de compte",
  editBusiness: "Modification d'opération",
  editConfig: "Modification de configuration",
  editInterBankTransfer: "Modification du Virement",
  editRemunerationRules: "Modification de clé de partage",
  editRole: "Modification de profile",
  editServiceChargeRules: "Modification de règle des frais",
  editServiceChargeRulesCountries: "création frais d'opération entre pays",
  employeesAccount: "Compte employé",
  endTime: "Date de fin",
  error: "Erreur",
  escrowAccount: "Compte sequester",
  bankEscrowAccount: "Compte bancaire",
  FileName: "Nom du fichier",
  exceptional: "anormalité",
  expenseManagement: "Gestion de dépenses",
  expenseList: "Liste de dépenses",
  expenseType: "Type de dépense",
  explain: "Explication",
  expireDate: "Date d’expiration",
  extend: "Extension",
  externalDeal: "Opération externe",
  failing: "Échouer",
  familyAddress: "Adresse",
  financial: "Financier",
  firstName: "Prénoms",
  fixedPrice: "Montant fixe",
  fixedPriceSettlement: "Règlement de montant fixe",
  foldMenu: "Réduire le menu",
  forbidden: "Désactiver",
  franchiseStoreAccount: "Distributeur",
  getApproved: "Valider",
  have: "Oui",
  home: "Accueil",
  homeCountry: "Pays",
  idCard: "Carte d'identité",
  idCardBack: "Recto de carte d'identité",
  idCardFront: "Verso de carte d'identité",
  "ID card front": "Pièce d'identité (recto)",
  "ID card back": "Pièce d'identité (verso)",
  idNumber: "Numéro d'identité",
  idCardType: "Type carte d'identité",
  ifThePsswordIsResetSuccessfullyItWillBeTheSameAsTheLoginAccount:
    "Si votre mot est réinitialisé avec succès, il sera le même pour le compte de connexion",
  image: "Photo",
  incident: "Incident",
  incidentDate: "Date incident",
  incidentType: "Type incident",
  incomeLevel: "Niveau de revenu",
  inProgress: "EN COURS",
  individualAccount: "Compte personnel",
  information: "Information",
  inputInfo: "Saisir l'information",
  inputPhoneOrAccount: "Saisir le numéro de téléphone ou du compte",
  interBankTransfer: "Virement inter-banque",
  internalDeal: "Opération interne",
  lastName: "Nom",
  legalForm: "Forme juridique",
  legalPerson: "Personne légale",
  legalPersonFirstName: "Prénoms",
  legalPersonIdCard: "Carte d'identité",
  legalPersonImage: "Photo",
  legalPersonLastname: "Nom",
  level: "Niveau",
  linkPhone: "Numéro de téléphone",
  loading: "Chargement……",
  // loginAccount: "Compte de connexion",
  loaginPassword: "Mot de passe de connexion",
  lock: "Verrouer",
  lockAccount: "Verrouillage de compte",
  lockApply: "Verrouer le compte",
  logOutApply: "Déconnecter le compte",
  login: "Connexion",
  loginAccount: "Nom d’utilisateur",
  loginPassword: "Mot de passe de connexion",
  mainBusiness: "Acitivité principale",
  maritalStatus: "État civil",
  maritalStatus0: "Célibataire",
  maritalStatus1: "Marié",
  maritalStatus2: "Divorcé",
  material: "Matériel",
  merchantLogin: "Connexion du marchand",
  merchantPayments: "Paiements du marchand",
  mobileAccountCheck: "Validation comptes mobiles",
  monetaryLimitation: "Limitation du montant",
  distributorMode: "Mode distributeur",
  distributorLite: "Distributeur lite",
  standard: "Standard",
  distributorModeHint:
    "Les agents partagent le pool du chef avec des seuils individuels",
  viewAgentThresholds: "Voir les seuils des agents",
  viewAgentThreshold: "Voir le seuil",
  agentThresholds: "Seuils des agents",
  confirmReset: "Êtes-vous sûr de vouloir réinitialiser la consommation nette ?",
agentThreshold: "Seuil agent",

netConsumed: "Consommation nette",
consumption: "Consommation",
noThresholdConfigured: "Aucun seuil configuré",
resetNetConsumed: "Réinitialiser consommation",
set: "Définir",

  active: "Actif",
  blocked: "Bloqué",

  name: "Nom",
  nation: "Pays",
  nationality: "Nationalité",
  nextStep: "Suivant",
  new: "NOUVELLE",
  newAmountLimit: "Nouveau montant",
  normal: "Normal",
  notApproved: "Non approuvé",
  notChargeNotConfig: "Sans frais, pas besoin de configuration",
  notHave: "Sans",
  notLoginPassword:
    "La taille du mot de passe doit être comprise entre 6 et 18 chiffres",
  notNull: "Ne pas pas être vide",
  note: "Message",
  notification: "Notification",
  notificationManage: "Notifications",
  number: "Numéro",
  numberCode: "Code numérique",
  object: "Objet",
  openClientAccount: "Ouverture compte personnel",
  openCompanyAccount: "Ouverture compte partenaire",
  operateSuccessfully: "Opération réussie",
  operationFailure: "Opération échouée",
  org: "Organisation",
  orgAddress: "Adresse",
  orgId: "Numéro d'ordre",
  orgInfo: "Information de base",
  orgManaged: "Organisation",
  orgName: "Nom",
  orgType: "Type",
  orgUserList: "Liste d'utilisateurs",
  other: "Autres",
  otherTransactionsReversal: "Autres opérations d'annulation",
  parentNode: "Parent",
  partnerAccount: "Compte partenaire",
  partnerId: "Partenaire ID",
  partnerName: "Nom du partenaire",
  partnerTransfers: "Virement partenaire",
  partnerTransferCheck: "Validation du virement",
  partnerInfo: "Information du virement",
  partnerInfoRemainingBalance: "Information du reliquat",
  partnersRemainingBalance: "Reliquat partenaires",
  totalAdvancedCustomerBalance: "Solde total partenaires",
  monthlyRemuneration: "Commission du mois",
  password: "Mot de passe",
  payApplicationCheckB: "Validation de recharge",
  payeePayment: "Payer par le bénéficiare",
  payeePayment2: "Frais inclus",
  payment: "Methode de payment",
  phone: "Téléphone",
  photograph: "Photo",
  platform: "Plateforme",
  platformAccount: "Compte plateforme",
  platformFee: "Frais de plateforme",
  platformFeeAmount: "Montant des frais",
  platformFeeProportion: "Proucentage des frais",
  please: "Veuillez",
  pleaseSelect: "Veuillez Sélectionner",
  pleaseSelectRemunerationTule: "Veuillez sélectionner la règle de partage",
  pleaseSelectServiceChargeTule:
    "Veuillez séectionner la règle des frais d'opération",
  pleaseUploadPictures: "Veuillez charger la photo",
  "Upload front and back of ID card. Replace blurry photos here.":
    "Téléchargez le recto et le verso de la pièce d'identité. Remplacez les photos floues ici.",
  "Image must be smaller than 5MB": "L'image doit être inférieure à 5 Mo",
  "Upload failed": "Échec du téléchargement",
  plus: "Ajouter",
  post: "Profession",
  post2: "Titre",
  prevStep: "Précédent",
  proportion: "Pourcentage",
  proportionSettlement: "Calcul de pourcentage",
  proportionSettlementAmount: "Montant de calcul de poucentage",
  province: "Région",
  provincial: "Régional",
  query: "Recherche",
  queryAccountInfo: "Recherche des informations de compte",
  queryChannelRewardADaySum: "Total commission (Journalier)",
  queryChannelRewardAMonthSum: "Total commission (Mensuel)",
  queryChannelRewardDetails: "Détails de commission",
  queryDeal: "Recherche d'opération",
  queryDepositB: "Recherche d'opération de dépôt",
  queryPlatformRewardADaySum: "Total commission (Journalier)",
  queryPlatformRewardAMonthSum: "Total commission (Mensuel)",
  queryPlatformRewardDetails: "Détails de commission",
  queryReward: "Recherche de commission",
  queryTransferB: "Recherche d'opération de transfert",
  queryWithdrawalsB: "Recherche d'opération de retrait",
  reason: "Raison",
  ApplyReason: "Motif",
  reset: "Rafraîchir",
  refresh: "Rafraîchir",
  region: "Région",
  regionalBalances: "Soldes régionaux",
  regionalAccounts: "Solde des agences",
  registerApply: "Demande d'ouverture de compte",
  registerCheck: "Validation d'ouverture de compte",
  registeredBusinessName: "Raison sociale",
  registeredOfficeAddress: "L'adresse du siège",
  registerTime: "Date d'ouverture",
  remark: "Remarque",
  remainingBalancePartners: "Versement reliquat partenaires",
  remainingBalancePartnersCheck: "Validation du reliquat",
  remittance: "Envoi",
  remittanceAmount: "Montant d'envoi",
  remittanceBusiness: "Opération d'envoi",
  remittanceInfo: "Information d'envoi",
  remittanceRemittance: "Nombre d'envoi",
  remittanceSum: "Cumul d'envoi",
  remittancesDrawMoney: "Retrait d'envoi",
  remittancesReversal: "Annulation d'envoi de compte",
  remitterInfo: "Information de l'expéditeur",
  remitterPayment: "Payer par l'expéditeur",
  remitterPayment2: "Frais à part",
  netAmountToSend: "Montant net à envoyer",
  toBeWithdraw: "Montant à retirer",
  remove: "Supprimer",
  remuneration: "Commission",
  remunerationManaged: "Commissions",
  remunerationRules: "Règle de commission",
  remunerationConfig: "Configuration commission",
  remunerationRulesConfig: "Clé de partage",
  //remunerationRules: "Règles de rémunération",
  requiredFields: "Champs obligatoires",
  resetLoginPassword: "Réinitialiser le mot de passe de connexion",
  resetPasswords: "Mot de passe",
  resourceMenu: "Menu des ressources",
  reversalBusiness: "Opération d'annulation",
  riskProfile: "Profil de risques",
  feed: "Alimenter",
  feedHistory: "Historique des alimentations",
  role: "Profile",
  roleManage: "Profiles",
  rolePermissionSet: "Autorisations du profile",
  routeName: "Nom de la route",
  searchable: "Peut être recherché",
  serviceCharge: "Frais d'opération",
  "service charge": "Frais d'opération",
  Servicechargeremittance: "Frais d'envoi",
  serviceChargeManaged: "Frais d'opération",
  serviceFeeRules: "Règle des frais d'opération",
  setAuthority: "Configuration d'autorisation",
  settlementAmount: "Montant d'opération",
  settlementRules: "Règle d'opération",
  orgLimitManaged: "Seuil de transaction",
  sex: "Sexe",
  sex0: "Féminin",
  sex1: "Masculin",
  slipReference: "Référence bordereau",
  shortName: "Nom court",
  sourceFee: "Commssion de distributeur",
  sourceFeeAmount: "Montant de la commission",
  sourceFeeProportion: "Pourcentage de commission",
  speciesName: "Nom",
  status: "État",
  startTime: "Date de début",
  subminCheckResult: "Soumettre le résultat de validation",
  submit: "Soumettre",
  success: "Succès",
  sum: "Nombre",
  systemConfig: "Configuration",
  systemSet: "Paramètrage global",
  template: "Modèle",
  time: "Temps",
  today: "Aujourd'hui",
  total: "Total",
  towardsLeft: "A gauche",
  towardsRight: "A droite",
  transferAccount: "Transfert de compte",
  transferBusiness: "Opération de transfert",
  transferInfo: "Information de transfert",
  transferReversal: "Annulation de transfert",
  transferorInfo: "Information de l'expéditeur",
  transfersOverrunCheckB: "Validation du dépassement de limite du transfert",
  //tradingBetweenCountry: "Opération entre pays",
  tradingBetweenCountry: "Opération entre villes",
  transaction: "Transaction",
  type: "Type",
  unbindDevices: "Délier l'Appareil client",
  unbindDevice: "Délier l'Appareil",
  unbind: "Délier",
  deviceName: "Nome de l'Appareil",
  OS: "Système",
  "Bind Time": "Date de Liaison",
  "Last Login": "Dernière Connexion",
  uniekeId: "Code d'identification unique",
  unlock: "Déverrouiller",
  unlockAccount: "Déverrouillage du compte",
  update: "Mis à jour",
  updateInformation: "Mis à jour des informations",
  upload: "Télécharger",
  uploadImage: "Télécharger la photo",
  urban: "Ville",
  user: "Utilisateur",
  userLogin: "Connexion",
  userName: "Nom d'utilisateur",
  verificationCode: "Code de vérification",
  warning: "Alerte",
  whetherToResetThe: "Réinitialisation",
  withdrawDepositCheckB: "Validation de recharge cash",
  withdrawalAmount: "Montant de retrait",
  withdrawalInfo: "Information de retrait",
  withdrawalsOverrunCheckB: "Validation du dépassement de limite recharge cash",
  withdrawerAddress: "Adresse",
  withdrawerInfo: "Information du client",
  maximumTenTabs: "Seulement 10 onglets peuvent être ouverts en même temps",
  pleaseEnterAccountOrTelephoneNumberQuery:
    "Veuillez entrer le numéro de compte ou de téléphone pour vérifier",
  customerList: "Liste des clients",
  companyAccount: "Compte entreprise",
  customerCode: "Code du client",
  customerName: "Nom et prénom",
  area: "Région",
  queryException: "Exception de requête",
  cardNumber: "Numéro de compte",
  accountAmount: "Solde du compte",
  commissionAmount: "Solde de commission",
  newAmount: "Montant à ajouter",
  AfterEnteringTheAmountItWillBAutomaticallyCalculated:
    "Le système calcule automatiquement après avoir saisi le montant",
  transactionId: "Numéro de transaction",
  amount: "Montant",
  messageAuthenticationCode: "Code de vérification SMS",
  incomeRecord: "Revenu",
  Inflows: "Entrées",
  Outflows: "Sorties",
  accountInfo: "Information du compte",
  noCommissionRuleWasFoundByBusinessNumber:
    "Selon le numéro d'operation, la règle de frais n'est pas trouvée",
  applyManage: "Gestion des demandes",
  rechargeApply: "Demande de recharge",
  rechargeAmount: "Montant de recharge",
  rechargeApplyList: "Liste des demandes de recharge",
  transferRechargeApply: "Demande de recharge de transfert",
  cashRechargeApply: "Demande de recharge de cash",
  withdrawDepositApply: "Demande de retrait",
  checkInfo: "Information de validation",
  checkRemark: "Remarques",
  applyAmount: "Montant de demande",
  applyTime: "Date de demande",

  applyUser: "Demandeur",
  bankTransferserial: "Rélévé des transferts bancaires",
  bankCheque: "Numero de cheque",
  transactionInfoId: "Numero d'opération",
  transfeDate: "Date de transfert",
  transferDatePartner: "Date du virement",
  verifyTime: "Date de validation",
  selectDateAndTime: "Sélection de date",
  cardManage: "Gestion des comptes",
  cardList: "Listes des cartes",
  accountCode: "Numéro du compte",
  range: "Intervalle",
  personal: "Personel",
  cashAmount: "Solde de caisse",
  cac: "Numéro de compte cash",
  frequencyLimit: "Limitation de frequence",
  sigleTradeLimit: "Limitation par transaction",
  maxTradyLimit: "Limitation du seuil",
  currentDepositLimit: "Plafond actuel",
  monthlyDepositLimit: "Plafond mensuel",
  customerDepositLimitManaged: "Plafond de dépôt client",
  orgUserId: "Numero d'utilisateur",
  cardQrCode: "Code QR de la carte",
  cashQrCode: "Code QR du compte cash",
  qrPayment: "Paiement QR marchand",
  calculating: "Calcul",
  accountName: "Nom du compte",
  cardRecord: "Rélévé de compte",
  afterAmount: "Solde après opération",
  beforeAmount: "Solde avant l'opération",
  businessType: "Type d'opération",
  transactionCode: "Code de transaction",
  financialStatements: "États financiers",
  remunerationStatements: "États des commission",
  "Remuneration agents": "Commissions des agents",
  remunerationAgents: "Commissions des agents",
  editLocalisation: "Modifier la localisation",
  invalidLongitude: "La longitude doit être comprise entre -180 et 180",
  invalidLatitude: "La latitude doit être comprise entre -90 et 90",
  "Invalid longitude: must be between -180 and 180":
    "La longitude doit être comprise entre -180 et 180",
  "Invalid latitude: must be between -90 and 90":
    "La latitude doit être comprise entre -90 et 90",
  localisation: "Localisation",
  notSet: "Non défini",
  saveLocalisation: "Enregistrer la localisation",
  pleaseCompleteTheInformationForFirstLogin:
    "Veuillez compléter les informations lors de votre première connexion",
  clickUpload: "Cliquez pour télécharger",
  dragTheFileHere: "Déplacez des fichiers vers ici",
  or: "Ou",
  pleaseCompleteYourInformationAfterTheApprovalOfTheDisplayFunction:
    "Veuillez compléter vos informations et la fonction pourra être affichée une fois validé",
  onlyJPGPNGFilesFanBeUploadedAndNoMoreThan500KB:
    "Seuls les fichiers jpg/png peuvent être téléchargés, et pas plus de 500 Ko",
  onlyUploadEXCELFileAndInXLSXOrXLSFormat:
    'Seuls les fichiers "EXCEL" peuvent être téléchargés, et ils sont au format xlsx, xls',
  youNeedToTeUploadAfterDeleting: "Re-télécharger après suppression",
  date: "Date",
  dateOfBirth: "Date de naissance",
  placeOfBirth: "Lieu de naissance",
  startDate: "Date début",
  endDate: "Date fin",
  detail: "Détail",
  position: "Fonction",
  "use excel to create": "Importer via Excel",
  "download template": "Télécharger le modèle",
  daysStatistical: "Statistiques par jour",
  monthlyStatistics: "Statistiques par mois",
  orgInfoId: "Numéro de l'entreprise",
  orgInfoCode: "Code d'organisation",
  platformRemunerationAmount: "Commission plateforme",
  sourceRemunerationAmount: "Commission d'agence",
  personalData: "Informations personelles",
  passwordManagement: "Gestion de mot de passe",
  logOut: "Déconnecter",
  ruleName: "Nom de la règle",
  personalCenter: "Centre personel",
  title: "Titre",
  content: "Contenu",
  unsent: "N'a pas ete envoyè",
  sent: "Déjà envoyé",
  general: "Ordianire",
  urgent: "Urgent",
  creatorName: "Nom de l'agent",
  createId: "ID de l'agent",
  orgCreated: "Compagny de l'agent",
  source: "Source",
  browseNumber: "Nombre de vues",
  addNotice: "Notification d'ajout",
  editNotice: "Notification d'èdition",
  sendNotice: "Notification d'envoie",
  homeVisible: "Page d'accueil visible",
  homeInvisible: "Page d'accueil non visible",
  clickNumber: "Nombre de clicks",
  noMore: "Y'a pas plus",
  cashManagement: "Gestion de cash",
  cashIssued: "Attribution caisse",
  cashToReceive: "Encaissement attribution",
  cashReceived: "Encaissée",
  cashPayback: "Récupération de cash",
  cashRecords: "Trace de cash",
  cashHandIn: "Décaissement",
  cashHandInCheck: "Validation décaissement",
  cashHandInApply: "Demande d'encaissement cash",
  remunerationToCash: "Encaissement commission",
  "add remunerationToCash": "Ajouter Encaissement Commission",
  "date remuneration To Cash": "Date d'Encaissement",
  remunerationToCashAmount: "Montant encaissé",
  bankingTransaction: "Opération bancaire",
  bankTransaction: "Opération bancaire",
  bankWithdrawal: "Retrait bancaire",
  bankOperationCheck: "Validation bancaire",
  bankAddress: "Banque adresse",
  totalCommissionAmount: "Commission Globale",
  remunerationType: "Type encaissement",
  //
  sendToSelf: "Envoi à moi même",

  wanted: "Sanctionnée",
  frozen_account: "Compte gelé",
  PPE: "PPE",
  monitoring: "Monitoring",

  low: "Faible",
  medium: "Moyenne",
  high: "Élevé",

  //

  failureReversal: "Échec annulation",
  completeReversal: "Annulation terminée",
  reversaling: "Annulation en cours",
  failureTransaction: "Échec de la transaction",
  completeTransaction: "Transaction terminée",
  trading: "Transaction en cours",
  await: "En attente",

  sanctioned_countries_list: "Liste des pays sanctionnés",
  listSanctionedCountries: "Pays sanctionnés",
  sanctioned: "Sanctionnés",
  sanctioned2: "Sanctionné",
  countryCode: "Code pays",

  //

  //bankDepositApply: "Demande ajouter un versement",
  refuseHandIn: "Encaissement réjeté",
  consentHandIn: "Encaissement validé",
  recoveryCash: "Cash recouvré",
  transferRecord: "Transfert",
  inputTradingCode: "Numero d'opération",
  remittanceRecord: "Envoi",
  transactionAmount: "Montant d'opération",
  tradingTime: "Date d'opération",
  tradingRecord: "Opération",
  transactionRemark: "Remarques",
  transaction_password: "Mot de passe de transaction",
  "Enter your transaction password": "Entrez votre mot de passe de transaction",
  invalidTransactionPassword: "Mot de passe de transaction invalide",
  cashRemittanceReversal: "Annulation d'envoi de caisse",
  accountRemittanceReversal: "Annulation d'envoi de compte",
  deposiReversal: "Annulation de dépôt de cash",
  withdrawalReversal: "Annulation de retrait de cash",
  submitReversal: "Demande d'annulation",
  receipt: "Reçu",
  receiptRemittance: "Reçu d'envoi",
  receiptWithrawal: "Reçu de retrait",
  receiptDeposit: "Reçu de Dépôt",
  sequenceNumber: "Numéro d'ordre",
  addOrg: "Création d’agence",
  batchOfRemittance: "Envoi multiple",
  select: "Sélection",
  applyOrgCusId: "Numéro du demandeur",
  orgCusName: "Nom de demandeur",
  selectPaymentMethodOfServiceFee:
    "Sélectionner la méthode de paiement des frais",
  printrRceipt: "Impression de reçu",
  printTable: "Impression du tableau",
  operator: "Opérateur",
  operateOrg: "Agence",
  remitterOrgName: "Agence d'envoi",
  tradeAssistant: "Agent",
  applyOrgUserId: "Agent ID",
  selectAssistant: "Sélectionner un Agent",
  addTradeAssistant: "Création d'agent",
  refundAmount: "Montant de remboursement",
  accountBalanceMustBeQqualTo: "Le solde de compte doit être égal à",
  orgUserName: "Nom d'utilisateur",
  customerId: "ID du client",
  unreceived: "Non retiré",
  received: "Retiré",
  receive: "Retrait",
  issuedCash: "Cash envoyé",
  reasonsForSubmission: "Raison de soumission",
  reasonsForRefusal: "Raison de refus",
  orgCode: "Numéro d'entreprise",
  creator: "Agent créateur",
  downloadEXCEL: "Télécharger EXCEL",
  downloadPDF: "Télécharger PDF",
  applyOrg: "Demandeur",
  whereaboutsFund: "Destination de fonds",
  affiliationOrg: "Affiliation",
  orgMember: "Membre",
  accountStatus: "État de compte",
  franchiseStore: "Distributeur",
  // lockAccount: "Compte déactivé",
  // unlockAccount: "Compte activé",
  "Download AFUWA MONEY App": "Télécharger l'appli AFUWA MONEY",
  "Download App": "Télécharger l'App",
  "Scan to verify transaction": "Scannez pour vérifier la transaction",
  "Customer Service": "Service client",
  updatePassword: "Changer le mot de passe",
  oldPassword: "Ancien mot de passe",
  newPassword: "Nouveau mot de passe",
  affirmPassword: "Confirmer le mot de passe",
  businessStatistics: "Statistique des opérations",
  "password changed successfully":
    "Modification de mot de passe réussi avec succès",
  "password changed failed": "Modification de mot de passe a échoué",
  tradingHour: "Date d'opération",
  cardNo: "Numéro de carte",
  serviceChageAmout: "Frais d'opération",
  cardNoBalance: "Solde de la carte",
  income: "Crédit",
  expenditure: "Débit",
  customerAccountService: "Services aux clients à compte",
  batchTransferAccounts: "Transfert multiple",
  transferAccounts: "Transfert de compte",
  "upload file contents": "Téléchargement de fichier",
  compellation: "Nom et prénom",
  "reselect file": "Sélectionner encore un fichier",
  "successfully upload": "Téléchargement réussi",
  listVisible: "Liste des élémments visibles",
  listInvisible: "Liste des éléments invisibles",
  "Drag the file here or": "Télécharger le fichier ici, ou",
  "click Upload": "Cliquer pour télécharger",
  "Only JPG/PNG files can be uploaded and no more than 500KB":
    "Ne peut charger des fichiers jpg/png, et pas plus de 500kb",
  "You need to re-upload after deleting":
    "Vous auriez besoin de télécharger à nouveau après suppression",
  "Please enter the number (e.g., 123, 0.123)":
    "Saisir un nombre (Ex : 123, 0.123)",
  "Three decimal places at most": "Maximum 3 decimal",
  "The length must be equal to 2 significant digits":
    "Doit être un nombre à 2 chiffres",
  "The length must be equal to 3 significant digits":
    "Doit être un nombre à 3 chiffres",
  "Must be a pure number": "Doit être un nombre",
  "Please enter Arabic numerals between 10 and 99, not including decimals":
    "Veuillez saisir un chiffre arabe compris entre 10 et 99, sans décimales",
  "You cannot include decimals": "Pas de décimal",
  "Must be a pure number (can start with 0)":
    "Doit être un nombre (peut commencer par 0)",
  "Please select audit status": "Sélectionner l'état de validation",
  "The login account cannot be empty":
    "Le compte de connexion ne peut pas être vide",
  "Password length must not be less than 6 characters":
    "Le mot de passe ne peut pas être inférieur à 6 chiffres",
  "Captcha length is not equal to 4":
    "La longueur du code de vérification n'est pas égale à 4",
  "SMS verification code sent successfully":
    "Code de vérification SMS envoyé avec succès",
  "Name of Remitter": "Nom de l'expéditeur",
  "The remittance voucher": "Reçu d'envoi",
  "The remittance amount": "Montant d'envoi",
  "Transaction no.": "Numéro de transaction",
  "Handling fee calculation": "Calcul des frais de transaction",
  "Withdrawal SMS verification code":
    "Code de vérification SMS pour le retrait",
  "Source of business": "Source de transaction",
  "click to download": "Cliquer sur download",
  "No template": "Pas de modèle",
  "transfer-template": "Modèle de transfert",
  "remittance-template": "Modèle d'envoi",
  "Send SMS verification code": "Envoi de code de vérification",
  "transfer amount": "Montant de transfer",
  "The amount transferred must not be greater than the account balance":
    "Le montant de transfert ne peut pas être supérieur au solde du compte",
  "send it again": "Renvoyer",
  "organization login": "Agence ou Distributeur",
  "member login": "Compte client",
  "Switch success": "Basculement réussi",
  cashLending: "Mise à disposition",
  cashLend: "Cash",
  accountLend: "Money électronique",
  "add cashLending": "Mise à disposition du Cash",
  accountLending: "Mise à disposition Money électronique",
  "add accountLending": "Mise à disposition Money électronique",
  "Verification code Receiving number":
    "Numéro de réception du code de vérification",
  "recent trading record": "Liste transactions récentes",
  "add record": "Ajouter",
  "acknowledging time": "Date de confirmation",
  "Payee org": "Agence bénéficiaire",
  Payee: "Bénéficiaire",
  "to be confirmed": "À confirmer",
  confirmed: "Confirmé",
  "Confirmed received": "Confirmé reçu",
  "in receipt of": "Reçu",
  "Please contact the piping personnel": "Veuillez contacter l'agent",
  remittorName: "Nom de l'expéditeur",
  remittor: "Expéditeur",
  remittorPhone: "Téléphone de l'expéditeur",
  payeeName: "Nom du bénéficiaire",
  payeePhone: "Téléphone du bénéficiaire",
  remittanceManagement: "Gestion des envois",
  remittanceList: "Liste des envois",
  pendingRemittances: "Envois non retirés",
  withdrawnRemittances: "Envois retirés",
  deletedRemittances: "Envois supprimés",
  cancelledRemittances: "Envois annulés",
  editedRemittances: "Envois modifiés",
  "remittance time": "Date d'envoi",
  "withdrawal time": "Date de retrait",
  "already withdrawal": "Retiré",
  "without withdrawal": "Non retiré",
  withdrawalOrg: "Agence de retrait",
  "edit payee info": "Modification",
  "query object": "Type de recherche",
  "to remitter": "Le code est envoyé à l'expéditeur",
  "My account information": "Les informations de mon compte",
  cashAccountRechargeApply: "Recharge de caisse",
  cashAccountRechargeCheck: "Validation de cash",
  virtualAccountRechargeApply: "Recharge de compte",
  virtualAccountRecharge: "Recharge Money électronique",
  virtualAccountRechargeCheck: "Validation de recharge",
  "Service Fee Payment Method": "Méthode de paiement des frais",
  "The trading data does not match the positive type":
    "Les données de transaction et d'annulation ne sont pas uniformes",
  "The transaction is not successful,not Cancel transaction":
    "Cette transaction est incomplète et ne peut pas être annulée",
  "Transaction in cancellation,Do not repeat operations":
    "Cette transaction est déjà encours d'annulation, veuillez ne pas répéter",
  "The transaction has been cancelled,Do not repeat operations":
    "Cette annulation est réussie, veuillez ne pas répéter",
  "Features are under development": "Fonction en cours de développement",
  "transaction voucher": "Reçu de transaction",
  "cash account": "Compte de caisse",
  "virtual account": "Compte virtuel",
  "trading status": "Statut de transaction",
  "Waiting transaction": "Opération en attente",
  "transaction progress": "Opération en attente",
  "transaction success": "Opération terminée",
  "transaction failing": "Opération échouée",
  "buy back progress": "Annulation encours",
  "buy back success": "Annulation réussie",
  "buy back failing": "Annulation échouée",

  //
  agent: "Agent",
  selectAgent: "Sélectionner un agent",
  myself: "Moi-même",
  // interBankTransfer: "Virement inter-bancaire",
  fromBank: "De la banque",
  toBank: "À la banque",
  transferCode: "Code de virement",
  referenceNumber: "Numéro de référence",
  transferDate: "Date de virement",
  transferAmount: "Montant du virement",
  transferFees: "Frais de virement",
  transferStatus: "Statut du virement",
  Pending: "En attente",
  Completed: "Terminé",
  Cancelled: "Annulé",

  //

  "remittance reason": "Raison du transfert",
  reason2: "Raison",
  "School aid": "Aide scolaire",
  "Family assistance": "Assistance familiale",
  "Building construction": "Construction immobilière",
  "Business settlement": "Règlement de biens",
  "Service settlement": "Règlement de service",
  "Debt repayment": "Remboursement dette",
  "Savings group": "Tontine",
  "Medical expenses": "Frais medicaux",
  Salary: "Salaire",
  "Solidarity fund": "Fond de solidarité",
  Back: "Retour",
  "The feature is under development": "En cours de développement",
  "Other business": "Autres opérations",
  otherConfig: "Autres configurations",
  "Open the configuration": "Ouvrir la configuration",
  "Close the configuration": "Fermer la configuration",
  "Platform maintenance fee configuration": "Configuration des frais SMS",
  "Shop account": "Compte marchant",
  "The end time cannot be later than 90 days after the start time":
    "L'intervalle de fin ne doit pas depasser 90 jours",
  "Enter the keyword to filter": "Saisir les mots clés   pour filtrer",
  city2: "Ville",
  "Please select business": "Sélectionner la transaction",
  "Transaction tax configuration": "Configuration de frais de timbre",
  "Transaction tax": "Frais de timbre",
  "transaction tax": "Frais de timbre",
  "Please select the remittance record": "Sélectionner un envoi",
  "Monthly deduction time": "Date prélèvement",
  day: "Jour",
  "The default value is the first day of each month":
    "Par défaut le 1er du mois",
  "unlock Apply": "Activer",
  "Platform maintenance cost": "Frais de plateforme",
  "platform remuneration": "Commission de plateforme",
  "organization remuneration": "Commission d'agence",
  "withdrawal organization remuneration": "Commission de retrait d'agence",
  "Whether to refund the handling fee": "Remboursement des frais",
  "Refund fee": "Frais remboursés",
  "Non-refundable service fee": "Frais non-remboursés",
  "Please choose whether to refund the service fee":
    "Sélectionner la methode de remboursement des frais",
  "The transfer template needs to be uploaded":
    "Veuillez charger le fichier de transfert",

  "Privacy Policy": "Politique de confidentialité",
  "about us": "Présentation de BNIF",
  "services us": "Nos Services",
  "contact us": "Nos Contacts",
  "Download app": "Télécharger l’app",

  "forget the password": "Mot de passe oublié?",
  "Send verification code": "Envoyer le captcha",
  "Please enter your login account and mobile phone number":
    "Veuillez entrer le compte de connexion avec le numéro de téléphone mobile",
  "There is no handling charge for transactions under":
    "Pas de frais pour les transactions inférieures à {money} ₣",
  "be on duty": "Ouverture de session",
  "off duty": "Fermeture de session",
  "It is out of hours and cannot handle business":
    "Le compte actuel est hors service et ne peut pas faire des affaires!",

  "Coupon exceeds max allowed": "La remise dépasse le maximum autorisé",
  "Service fee discount": "Réduction sur les frais de manutention",
  "Service fee discount2": "Réduction sur les rémise",
  "after discount service": "Frais de manutention préférentiels",
  "sales network": "Liste des agences",
  salesNetwork: "Liste des agences",
  orgRemittancesRanked: "Classement des agences",
  // "Remittances ranked": "Classement des transferts",
  //partnerRemittanceRanking: "Classement des partenaires",
  partnerRemittanceRanking: "Classement des clients",
  network: "Réseaux",
  "Note: After successful operation, we need to wait for the approval of the platform and the organization, and the account will be received after the approval":
    "Attention: après l’opération réussie, vous devez attendre la vérification de la plate-forme et de l’agence. Après l’approbation de la vérification, vous arriverez au compte",

  batchOperationReview: "Transactions multiples",
  batchOperationApply: "Application de trading de volume",
  "transaction account": "compte courant",
  "transaction time": "Heures de trading",
  "transaction EXCEL name": "Nom EXCEL de la transaction",

  "transaction info": "Informations sur transactions",
  "proceeds info list": "Liste des informations de collecte",
  "Batch transfer review": "Audit de transfert de masse",
  "Batch remittance review": "Audit de transfert de masse",
  "Advanced Customer History": "Historique des partenaires",
  "Adding a Customer Account": "Création de partenaire",
  platformForCustomer: "Création de partenaire",
  "platform opens customer accounts": "Plateforme ouvrir un compte client",
  phoneWillBeUsername: "Votre numéro de téléphone sera votre nom d'utilisateur",
  thisWillBeYourUsername:
    "Ceci sera votre nom d'utilisateur pour vous connecter",
  "Initial amount": "Solde initial",
  "Edit account": "Modifier",
  totalRemittance: "Total envois",
  "Total bank withdrawal": "Total retraits bank",
  "Total cashToReceive": "Total encaissements",
  "Total others cashToReceive": "Total encaissés divers",

  "Total withdrawal": "Total de retraits",
  "Total cashLending": "Total mises à disposition",
  "Total expenses": "Total dépenses",
  "Total bank deposit": "Total verses bank",
  "Total removed remittance": "Total envois supprimés",
  "Total cancel remittance": "Total envois annulés",
  "Total amount": "Montant Total",
  "Total Platform Com": "Total Com Plateforme",
  "Total Source Com": "Total Com Agence",

  "Regularization amount": "Régularisation Solde",
  "Virtual amount": "SOLDES VIRTUELS",
  "Reals amount": "SOLDES REELS",
  "Final balance": "SOLDE FINAL",
  GAP: "ECART",

  "Adding a Bank Account": "Création de compte bancaire",
  withdarwMoneyCode: "Code d'envoi",
  withdrawalCode: "Code de retrait",
  withdrawalCodePlaceholder: "Saisir le code de retrait",
  useCode: "Utiliser le code",
  useIdCard: "Utiliser la CNI",
  finance: "finances",
  manager: "manager",
  //organizationMembersRanking: "Classement des membres institutionnels",
  organizationMembersRanking: "Classement par agent ",

  //接口返回异常
  "100001:wrong phone": "Le numéro de téléphone ne correspond pas au compte",
  "100004:The sms code is incorrect.": "Le code SMS est incorrect",

  "100002:the account or password is empty":
    "Le nom ou le mot de passe ne doit pas être vide",
  "100003:The account has been locked": "Le compte a été bloqué",
  "100003:The account has been locked, please try again in 2 hours.":
    "Le compte a été bloqué, veuillez réessayer dans 2 heures",
  "100005:You need to log in again": "Veuillez vous reconnecter à nouveau",
  "100005:The login has expired and you need to login again":
    "Veuillez vous reconnecter à nouveau",

  "100004:Account or password error 1 times, also can retry 4 time.":
    "Le compte ou le mot de passe est erroné 1 fois, et vous pouvez réessayer 4 fois",
  "100004:Account or password error 2 times, also can retry 3 time.":
    "Le compte ou le mot de passe est erroné 2 fois, et vous pouvez réessayer 3 fois",
  "100004:Account or password error 3 times, also can retry 2 time.":
    "Le compte ou le mot de passe est erroné 3 fois, et vous pouvez réessayer 2 fois",
  "100004:Account or password error 4 times, also can retry 1 time.":
    "Le compte ou le mot de passe est erroné 4 fois, et vous pouvez réessayer 1 fois",
  "100004:The verification code is incorrect.":
    "Code de vérification incorrect",
  "100004:The account password or verification code is incorrect":
    "Mot de passe incorrect",

  "100011:cannot operate: same organization":
    "Opération impossible : même organisation",

  "100012:organization cannot be null": "L'agence est requise",

  "200001:no data": "Pas de données",
  "200006:no partner found": "Pas de Partenaire trouvé",
  "200002:Required parameter, cannot be empty":
    "Paramètre obligatoire, ne peut pas être vide",
  "200002:Transaction type cannot be empty":
    "Type d'opération, ne peut pas être vide",
  "200003:serviceCharge not found":
    "Aucune règle de frais correspondante trouvée",
  "200003:withdarwMoneyCode parameter error": "Erreur de code de retrait SMS",
  "200003:parameter error": "Erreur de donnée",
  "200003:old password error": "Erreur de l'ancien mot de passe",
  "200002:the bank information cannot be blank":
    "Les informations de banques ne doivent pas être vides",
  "200002:code is empty": "Code de vérification ne doit pas être vide ",
  "200002:the resource ids is empty": "Code de ressource est vide",
  "200003:payeeDetailsId parameter error": "Erreur des détails du bénéficiaire",
  "200003:transactionInfoId parameter error": "Erreur de code de transaction",
  "200003:cardNo parameter error": "Erreur de numéro de carte",
  "200003:cardId or cardNo parameter error": "Erreur de numéro de carte",
  "200003:startTime or endTime parameter error": "Erreur de date",
  "200003:applyId parameter error": "Erreur du numéro de demande",
  "200003:transferCode parameter error": "Erreur de code de transfert",
  "200003:referenceNumber parameter error": "Erreur de numéro de référence",
  "200003:cannot transfer, bank are same":
    "Ne peut pas transférer, les banques sont les mêmes",
  "200003:status parameter error": "Erreur d'état",
  "200003:transferRecord parameter error":
    "Erreur de numéro d'enregistrement de virement",
  "200003:transfeTime parameter error": "Erreur de temps de transfert",
  "200003:orgInfoId parameter error": "Erreur des informations d'organisation",
  "200003:id parameter invalid": "Code invalide",
  "200003:orgId parameter error": "Erreur des informations d'organisation",
  "200003:customerId parameter error": "Erreur de code client",
  "200003:idCard parameter error": "Erreur de numero d'identité",
  "200003:country or region parameter error": "Erreur de pays ou région",
  "200003:orgInfoCode parameter error": "Erreur de code d'organisation",
  "200003:numberCode parameter error": "Erreur de code numérique",
  "200003:level parameter error": "Erreur de niveau",
  "200003:isOrgCus parameter error":
    "Erreur de sélection d'organisation du client",
  "200003:businessType parameter error": "Erreur de type de transaction",
  "200003:parentId parameter error": "erreur de code parental",
  "200003:settlementRules parameter error": "Erreur de règle de calcul",
  "200003:id parameter error": "Erreur de numero d'identité",
  //"200003:status parameter error": "Erreur d'état",
  "200003:orgCum parameter error": "Erreur de code d'organisation du client",
  "200003:type parameter error": "Erreur de type de données",
  "200003:operationType parameter error": "Erreur de type d'opération",
  "200003:payServiceChargeType parameter error": "Erreur de paiement de frais",
  "200003:businessCode parameter error": "Erreur de code de transaction",
  "200003:remittorCardId or remittorCardNo parameter error":
    "Erreur de numéro de carte de l'expéditeur",
  "200003:remittorCardNo parameter error": "Erreur de carte de l'expéditeur",
  "200003:payeeCardNo parameter error": "Erreur de carte du bénéficiaire",
  "200003:payeeCardId or payeeCardNo parameter error":
    "Erreur de numéro de carte du bénéficiaire",
  "200003:orgUserId parameter error, there is no card information":
    "Erreur d'utilisateur,le compte non trouvé",
  "200003:mainOrgCardId parameter error": "Erreur de carte principale",
  "200003:Only franchised outlets can be set as distributor lite":
    "Seuls les distributeurs peuvent être définis comme distributeur lite",
  "200005:permission denied": "Permission refusée",

  "300001:not sufficient funds": "Solde insuffisant",
  "300002:duplicate login name": "Ce nom de compte est déjà enregistré",
  "300003:The phone to repeat": "Ce numéro de téléphone est déjà enregistré",
  "300004:Operate too often": "L'opération est trop fréquente",
  "300005:no serviceCharge rule found":
    "Aucune règle de frais correspondante trouvée",
  "300006:sms code is incorrect or expired": "Code SMS incorrect ou expiré",
  "300001:remittor not sufficient funds":
    "Le solde de l'expéditeur est insuffisant",
  "300007:transaction tax anomaly": "Anomalie sur la taxe de transaction",
  "300008:Bank Account amount is not sufficient":
    "Le solde du compte bancaire est insuffisant.",
  "300008:account amount is not sufficient":
    "Le solde du compte est insuffisant.",
  "300008:not sufficient funds": "Solde insuffisant",
  "300009:applied amount exceeds the current deposit limit":
    "Le montant demandé dépasse la limite de dépôt actuelle",
  "300010:applied amount exceeds the monthly deposit limit":
    "Le montant demandé dépasse la limite de dépôt mensuelle",
  "300011:org remittance limit exceeded":
    "Vous avez atteint la limite du seuil",
  "300012:org deposit limit exceeded": "Limite de dépôt de l'agence dépassée",

  "400001:no card account": "Aucune carte sur compte",
  "400001:cash lending not found": "Prêt en espèces introuvable",
  "400001:Transaction limits configuration not found":
    "Configuration des limites de transaction introuvable",
  "400001:serviceChargeAmount surpass amount":
    "Les frais dépassent le montant de transaction",
  "400001:payee card account unavailable":
    "Le compte bénéficiaire n'est pas actif",
  "400001:remittor card account unavailable":
    "Le compte expéditeur n'est pas actif",
  "400001:payee customer unavailable":
    "Le status du bénéficiaire n'est pas actif",
  "400001:remittor customer unavailable":
    "Le status de l'expéditeur n'est pas actif",
  "400001:The affiliation organization is not available":
    "L'organisation affiliée n'est pas active",
  "400001:apply record status error": "Erreur de status de demande",
  "400001:businessCode not found": "Le code de transaction est introuvable",
  "400001:service charge or remuneration not found":
    "Les frais de transaction et de commission est introuvable",
  "400001:new customer failure": "Ajout de client échoué",
  "400001:new customer role failed": "Echec d'ajout de profile",
  "400001:new customer transaction failed": "Echec d'ouverture de compte",
  "400001:new application failed": "Echec de demande d'ouverture de compte",
  "400001:failed to generate a card account": "Echec d'ajout de compte",
  "400001:there is no get customer information through customerId":
    "Les informations du client non retrouvées",
  "400001:customer status unavailable": "Le status de client n'est pas actif",
  "400001:card account not found": "Le compte est introuvable",
  "400001:customer card account status unavailable":
    "Le compte client n'est pas actif",
  "400001:amount greater than 5000": "Le montant dépasse 5000",
  "400001:amount less than 5000": "Le montant est inférieur à 5000",
  "400001:no serviceCharge rule found":
    "Aucune règle de frais correspondante trouvée",
  "400001:operation failure": "L'opération a échoué",
  "400001:No user account found":
    "Veuillez utiliser le compte agent pour opérer",
  "400001:(serviceChargeAmount)Calculating fees is different from passing in fees":
    "Anormalie de calcul des frais",
  "400001:Failed to operate customer account": "Annlation échouée",
  "400001:The transaction has been completed!":
    "Transactions terminées ne peuvent pas être annulées",
  "400001:serviceChargeAmount Calculation of different":
    "Erreur de calcul de frais",
  "400001:serviceCharge rule and remuneration rule  not found":
    "Règle de frais et de commission non retrouvée",
  "400001:the status doesn't need to change":
    "Le status n'a pas besoin d'être changé",
  "400001:already existed organization": "Organisation existe déjà",
  "400001:have balance": "Solde n'est pas nul",
  "400001:data repetition": "Donnée répetée",
  "400001:please check the account balance": "Vérifier le solde de compte",
  "400001:date must be limited": "Date dit être limitée",
  "400001:the query range cannot exceed 93 days":
    "L'intervalle de recherche ne doit pas exèder 93 jours",
  "400001:upload failed, file is empty": "Téléchargement échoué，aucun fichier",
  "400001:upload failed, unsupported suffix":
    "Téléchargement échoué，ne supporte pas le format",
  "400001:upload failed, not upload image type":
    "Téléchargement échoué，ne supporte pas le type d'image",
  "400001:the current organization is not available": "Organisation inactive",
  "400001:account unavailable": "Compte inactif",
  "400001:customer unavailable": "Client inactif",
  "400001:create transactionInfo failure": "Création ",
  "400001:please check the balance of the main account":
    "Vérifier le solde du compte",
  "400001:please check the cash account balance":
    "Vérifier le solde de la caisse",
  "400001:please check it,the status has been processed":
    "Confirmer le status，s'il n'a pas changé",
  "400001:remittance data does not exist": "Les données d'envoi n'existent pas",
  "400001:the code has expired": "Le code de retrait a échoué",
  "400001:no batch data": "Il n'ya pas les données multiple",
  "400001:please import XLS, XLSX format files of type Excle":
    "Importer un fichier Excel de format XLS, XLS",
  "400001:the number of imports is more than 10,000":
    "La quantité a dépasser 10 000",
  "400001:there is no record of a transaction":
    "Il n'y' pas les données de transaction",
  "400001:status error": "Erreur de status",
  "400001:Balance update failed for bank account":
    "Échec de la mise à jour du solde bancaire",
  "400001:customer's original organization profile does not exist":
    "Organisation liée au client n'existe pas",
  "400001:the amount of overrun": "Le montant dépasse la limite",
  "400001:the total amount of overrun": "Le montant total dèpasse la limite",
  "400001:the frequency of overrun": "La fréquence dépasse la limite",
  "400002:bank not fund": "La banque n'existe pas",
  "400003:apply amount must be positive": "Le montant doit être positif",
  "200003:accountMaintenanceFees must be positive":
    "Le frais de maintenance doit être positif",

  "200003:fees must be positive": "Le frais de transaction doit être positif",

  // alert
  "500001:this person is on the wanted person list":
    "Transaction bloquée, cette person est recherchée",
  "500002:transaction added to alert list":
    "Transaction ajoutée à la liste des alertes",
  "500003:duplicate country": "Ce pays est déjà enregistré",

  // expense
  "Operational Expenses": "Dépenses Opérationnelles",
  "Personnel Expenses": "Dépenses de Personnel",
  "Banking and Financial Transaction Expenses":
    "Dépenses Bancaires et Transactions Financières",
  "Marketing and Business Development": "Marketing et Développement Commercial",
  "Other Expenses": "Autres Dépenses",

  //
  orgOrigin: "Provénance",
  orgDestination: "Destination",
  //faddServiceChargeRulesCountries
  "Country of Origin": "Pays de Provénance",
  "Destination Country": "Pays de Destination",
  //
  "City of Origin": "Ville de Provénance",
  "Destination City": "Ville de Destination",
  //
  "Total Remittance": "Total envoi",
  "Total Remittance Fees": "Total frais d'envoi",
  "Remittance Fees": "Frais d'envoi",
  "Total VAT on Remittance": "Total TVA d'envoi",
  "Total Stamp Duty on Remittance": "Total Timbre d'envoi",
  "Total of Clients": "Nbre de clients",
  "Remittances whose country of origin is":
    "Les envois dont le pays de provénance est",
  "Validate Remittance Data": "Validation des données pour l'envoi",
  "Confirm and Submit": "Confimer et Soumettre",
  "Validate Account Data": "Validation des données de compte",
  "no data": "Pas de données",
  "Global validation": "Validation globale",
  "Coordinator validation": "Validation coordinateur",
  "Admin validation": "Validation admin",
  //"": "",
  //"": "",

  "500:An error occurred inside the program":
    "Une exception s'est produite dans le programme",
  "500:please contact the piping personnel":
    "Anomalie, contacter l'administrteur",

  systemError: "Erreur système, veuillez réessayer",
  httpError: "Erreur HTTP",
  serverUnreachable: "Serveur inaccessible, vérifiez votre connexion",

  // Alert Dashboard
  criticalAlerts: "Critiques",
  warningAlerts: "Avertissements",
  infoAlerts: "Informations",
  totalUnresolved: "Total Non Résolus",
  alertsByType: "Alertes par Type",
  recentAlerts: "Alertes Récentes",
  unread: "Non lus",
  markRead: "Marquer comme lu",
  resolve: "Résoudre",
  resolved: "Résolu",
  resolveAlert: "Résoudre l'Alerte",
  resolutionNote: "Note de Résolution",
  enterResolutionNote: "Entrez la note de résolution...",
  markedAsRead: "Marqué comme lu",
  alertResolved: "Alerte résolue avec succès",
  alertCheckCompleted: "Vérification des alertes terminée",
  viewAllAlerts: "Voir Toutes les Alertes",
  checkNow: "Vérifier Maintenant",
  alertSettings: "Paramètres d'Alerte",
  noAlertsFound: "Aucune alerte trouvée",

  // Alert Types
  lowBankBalance: "Solde Bancaire Faible",
  lowAgencyBalance: "Solde Agence Faible",
  lowCardBalance: "Solde Carte Faible",
  lowCashBalance: "Solde de caisse faible",
  pendingFundsHigh: "Mise à Disposition Élevée",
  unresolvedIncident: "Incident Non Résolu",
  largeTransaction: "Transaction Importante",
  failedTransactionRate: "Taux d'Échec Élevé",
  pendingCashLending: "Prêt en attente de confirmation",

  // Severity
  critical: "Critique",
  quickActions: "Actions Rapides",
  //warning: "Avertissement",
  //information: "Information",
  severity: "Gravité",
  alertTitle: "Titre de l'alerte",

  // Common
  entity: "Entité",
  currentValue: "Valeur Actuelle",
  threshold: "Seuil",
  //createdAt: "Créé le",

  destinationType: "Type de Destination",
  organization: "Organisation",

  escrowAccountPlaceholder: "Les fonds seront envoyés au compte séquestre",
  pleaseSelectDestination: "Veuillez sélectionner le type de destination",
  sendToEscrow: "Envoyer au Compte Séquestre",

  confirmCancelLending: "Êtes-vous sûr de vouloir annuler cette opération?",
  operationCancelled: "Opération annulée",

  Suggestions: "Suggestions et commentaires",
  suggestions: "Suggestions",
  "Submit Suggestion": "Soumettre",
  "Suggestion Title": "Titre",
  "Suggestion Description": "Description",
  "Suggestion Type": "Type",
  "Bug Report": "Signaler un bug",
  "Feature Request": "Demande de fonctionnalité",
  "General Feedback": "Commentaire général",
  Complaint: "Réclamation",
  "Your suggestion has been submitted":
    "Votre suggestion a été soumise avec succès",

  "Enter suggestion title": "Entrez un titre bref",
  "Enter detailed description": "Entrez une description détaillée",
  "Select suggestion type": "Sélectionnez le type",
  "Character count": "Nombre de caractères",

  // API Messages
  "Suggestion submitted successfully": "Suggestion soumise avec succès",
  "Failed to save suggestion": "Échec de l'enregistrement de la suggestion",
  "Description too short": "Description trop courte",
  "Required fields missing": "Champs obligatoires manquants",
  "Submit failed": "Échec de la soumission",

  updateTime: "Dernière mise à jour",
  adminReply: "Réponse de l'admin",

  "Under Review": "En cours d'examen",
  Resolved: "Résolu",
  Rejected: "Rejeté",

  //
};
